import React, { useState, useEffect, Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';

// Components
import AlertComponent from './components/common/AlertComponent';
import LoadingOverlay from './components/common/LoadingOverlay';
import SettingsModal from './components/modals/SettingsModal';
import './App.css';

// Lazy load page components
const ScannerPage = lazy(() => import('./components/scanner/ScannerPage'));
const ReportsPage = lazy(() => import('./components/reports/ReportsPage'));
const StockReportsPage = lazy(() => import('./components/reports/StockReportsPage'));
const DesignRackLocationReportPage = lazy(() => import('./components/reports/DesignRackLocationReportPage'));
const SavedListPage = lazy(() => import('./components/sessions/SavedListPage'));
const EditSessionPage = lazy(() => import('./components/sessions/EditSessionPage'));

const BarcodeScanner = () => {
  // Global app state
  const [alertMessage, setAlertMessage] = useState(null);
  const [editingSession, setEditingSession] = useState(null);
  const [editingItemName, setEditingItemName] = useState(null);
  const [loading] = useState(false);
  const [apiLoading] = useState(false);

  // Settings modal state
  const [showSettings, setShowSettings] = useState(false);

  // Auto-dismiss alerts
  useEffect(() => {
    if (alertMessage) {
      const timer = setTimeout(() => {
        setAlertMessage(null);
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, [alertMessage]);

  const showAlert = (message, type = 'info', barcode = null, existingRack = null) => {
    setAlertMessage({
      message,
      type,
      barcode,
      existingRack
    });
  };

  const clearAlert = () => {
    setAlertMessage(null);
  };

  return (
    <Router>
      <div className="App">
        <AlertComponent alertMessage={alertMessage} clearAlert={clearAlert} />
        <LoadingOverlay loading={loading} apiLoading={apiLoading} />
        <SettingsModal 
          showSettings={showSettings}
          setShowSettings={setShowSettings}
        />
        
        <Suspense fallback={<div className="flex items-center justify-center min-h-screen">Loading...</div>}>
          <Routes>
            <Route path="/" element={
              <ScannerPage
                setShowSettings={setShowSettings}
                showAlert={showAlert}
                editingItemName={editingItemName}
                setEditingItemName={setEditingItemName}
              />
            } />
            
            <Route path="/reports" element={
              <ReportsPage
                setShowSettings={setShowSettings}
                showAlert={showAlert}
              />
            } />
            
            <Route path="/stock-reports" element={
              <StockReportsPage
                setShowSettings={setShowSettings}
              />
            } />
            
            <Route path="/design-rack-location" element={
              <DesignRackLocationReportPage
                setShowSettings={setShowSettings}
              />
            } />
            
            <Route path="/saved-list" element={
              <SavedListPage
                setShowSettings={setShowSettings}
                showAlert={showAlert}
              />
            } />
            
            <Route path="/edit-session" element={
              <EditSessionPage
                editingSession={editingSession}
                setShowSettings={setShowSettings}
                showAlert={showAlert}
                setEditingSession={setEditingSession}
              />
            } />
            
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </Suspense>
      </div>
    </Router>
  );
};

export default BarcodeScanner;